<template>
  <div>
    <div class="cover cover--small" :style="'background-image: url(' + require('@/assets/cover-about.jpg') + ')'">
      <h1 class="cover__title">Meet Aaron</h1>
    </div>
    <div class="white-box wrapper wrapper--spaced">
      <p class="text">Aaron Gunn is an independent journalist and advocate for taxpayers and common sense. He was born and raised in Victoria, B.C., and received a Bachelor’s Degree of Commerce from the University of Victoria. He then served three years in the Canadian Army Reserves while operating his own company, which he founded at age 15.</p>
      <p class="text">Politically minded from a young age, Aaron joined the Canadian Taxpayers Federation (CTF) where he founded and became Executive Director of the Generation Screwed initiative, fighting back against government debt and its impact on future generations. By the end of his tenure at the CTF, Generation Screwed had achieved a considerable online following and established a physical presence at over 30 university campuses across Canada.</p>
      <p class="text">Since leaving the CTF, Aaron personally built the single-largest social media following for any political figure in British Columbia. With over 50 million video views and tens of thousands of followers, he is the leading political voice for countless British Columbians.</p>
      <p class="text">Aaron is also Producer/Director of the hit online series, Politics Explained, which includes exclusive interviews with Rex Murphy, Pierre Poilievre, Conrad Black and more.</p>
      <p class="text">Aaron is now prepared to put his advocacy into action and become the next Premier of British Columbia.</p>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>
